import React from "react";
import resume from "../../files/Yi Liu_resume.pdf";

const Bottom = () => {
  return (
    <div className="bottom pt-3 pt-md-5" id="contact">
      <div className="container">
        <h2 className="text-center">Contact</h2>
        <p className="lead text-center">
          <span>Want to know more? </span>
          <span>Contact me and I will tell you my story!</span>
        </p>
        <hr />
        <div className="row">
          <div className="col-md-6">
            <ul>
              <li>
                <a
                  href="https://www.linkedin.com/in/yliu481/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="1888"
                    height="32"
                    width="32"
                  >
                    <path
                      d="M896 64H127.8C92.6 64 64 93 64 128.6v766.8C64 931 92.6 960 127.8 960H896c35.2 0 64-29 64-64.6V128.6c0-35.6-28.8-64.6-64-64.6zM334.8 832H202V404.4h133V832z m-66.4-486c-42.6 0-77-34.6-77-77S225.8 192 268.4 192c42.4 0 77 34.6 77 77 0 42.6-34.4 77-77 77z m564.2 486h-132.8V624c0-49.6-1-113.4-69-113.4-69.2 0-79.8 54-79.8 109.8V832h-132.8V404.4h127.4v58.4h1.8c17.8-33.6 61.2-69 125.8-69 134.4 0 159.4 88.6 159.4 203.8V832z"
                      p-id="1889"
                    ></path>
                  </svg>
                  https://www.linkedin.com/in/yliu481/
                </a>
              </li>
              <li>
                <a href="mailto:liuy2033@gmail.com">
                  <svg
                    viewBox="0 0 1385 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2732"
                    height="32"
                    width="32"
                  >
                    <path
                      d="M1226.571294 36.442353h-1090.258823c-74.992941 0-136.312471 54.211765-136.312471 120.470588v722.82353c0 66.258824 61.319529 120.470588 136.312471 120.470588h1090.258823c74.992941 0 136.312471-54.211765 136.312471-120.470588v-722.82353c0-66.258824-61.319529-120.470588-136.312471-120.470588z m0 240.941176l-545.129412 301.176471-545.129411-301.176471v-120.470588l545.129411 301.176471 545.129412-301.176471v120.470588z"
                      p-id="2733"
                    ></path>
                  </svg>
                  liuy2033@gmail.com
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-6">
            <ul>
              <li>
                <a
                  href="https://github.com/yliu481"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="3044"
                    height="32"
                    width="32"
                  >
                    <path
                      d="M1021.72444445 512a495.16088889 495.16088889 0 0 1-97.57582223 299.64515555 500.62222222 500.62222222 0 0 1-250.85724444 184.22897778 30.58346667 30.58346667 0 0 1-26.2144-4.73315555 25.85031111 25.85031111 0 0 1-8.00995556-20.02488889v-139.81013334a119.05706667 119.05706667 0 0 0-34.58844444-94.29902222 473.31555555 473.31555555 0 0 0 67.72053333-11.65084444 248.30862222 248.30862222 0 0 0 62.2592-26.2144 187.50577778 187.50577778 0 0 0 53.52106667-43.69066667 209.35111111 209.35111111 0 0 0 36.40888889-69.90506667 334.2336 334.2336 0 0 0 13.83537778-100.12444444 191.87484445 191.87484445 0 0 0-52.7928889-136.53333333 176.21902222 176.21902222 0 0 0-5.09724444-135.44106667 87.01724445 87.01724445 0 0 0-53.52106666 7.28177778 341.87946667 341.87946667 0 0 0-61.16693334 29.12711111l-25.12213333 15.65582222a473.31555555 473.31555555 0 0 0-254.86222223 0c-7.28177778-5.09724445-16.384-10.55857778-28.03484444-17.84035555A371.00657778 371.00657778 0 0 0 300.82844445 220.72888889a94.29902222 94.29902222 0 0 0-57.16195556-9.10222222 178.40355555 178.40355555 0 0 0-4.73315556 136.53333333 197.70026667 197.70026667 0 0 0-52.4288 137.26151111A327.68 327.68 0 0 0 200.33991111 584.81777778a223.55057778 223.55057778 0 0 0 36.40888889 69.90506667 172.94222222 172.94222222 0 0 0 53.52106667 44.41884444 304.7424 304.7424 0 0 0 62.2592 26.2144 471.13102222 471.13102222 0 0 0 68.08462222 11.65084444 105.22168889 105.22168889 0 0 0-32.768 68.44871112 112.86755555 112.86755555 0 0 1-30.21937778 9.4663111 190.41848889 190.41848889 0 0 1-36.40888889 3.2768A78.6432 78.6432 0 0 1 274.61404445 803.27111111a124.5184 124.5184 0 0 1-36.4088889-41.50613333 109.22666667 109.22666667 0 0 0-32.03982222-34.58844445 91.7504 91.7504 0 0 0-32.768-16.01991111h-13.1072a47.33155555 47.33155555 0 0 0-19.29671111 2.91271111q-5.46133333 3.2768-3.2768 7.64586667a50.24426667 50.24426667 0 0 0 6.18951111 9.10222222 62.98737778 62.98737778 0 0 0 8.73813334 8.37404445l4.73315555 2.91271111a88.83768889 88.83768889 0 0 1 29.12711111 25.12213333 179.49582222 179.49582222 0 0 1 20.75306667 33.49617778l6.5536 15.29173333a82.28408889 82.28408889 0 0 0 29.12711111 41.14204445 109.22666667 109.22666667 0 0 0 44.05475556 18.93262222 223.18648889 223.18648889 0 0 0 45.8752 4.73315556 207.16657778 207.16657778 0 0 0 36.40888888-2.54862223l15.29173334-2.54862222v95.39128889a26.2144 26.2144 0 0 1-8.73813334 20.02488889 31.67573333 31.67573333 0 0 1-26.57848888 4.73315555 498.43768889 498.43768889 0 0 1-249.40088889-185.32124444A486.78684445 486.78684445 0 0 1 2.27555555 512a497.70951111 497.70951111 0 0 1 68.44871112-254.86222222A504.6272 504.6272 0 0 1 257.13777778 70.72426667 497.70951111 497.70951111 0 0 1 512 2.27555555a497.70951111 497.70951111 0 0 1 254.86222222 68.44871112A504.6272 504.6272 0 0 1 953.27573333 257.13777778 496.98133333 496.98133333 0 0 1 1021.72444445 512z"
                      p-id="3045"
                    ></path>
                  </svg>
                  https://github.com/yliu481
                </a>
              </li>

              <li>
                <a
                  href="https://github.com/yliu481"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <svg
                    viewBox="0 0 1024 1024"
                    version="1.1"
                    xmlns="http://www.w3.org/2000/svg"
                    p-id="2675"
                    height="32"
                    width="32"
                  >
                    <path
                      d="M739.555556 56.888889H284.444444a56.888889 56.888889 0 0 0-56.888888 56.888889v796.444444a56.888889 56.888889 0 0 0 56.888888 56.888889h455.111112a56.888889 56.888889 0 0 0 56.888888-56.888889V113.777778a56.888889 56.888889 0 0 0-56.888888-56.888889z m-297.528889 42.097778h142.222222a14.222222 14.222222 0 1 1 0 28.444444h-142.222222a14.222222 14.222222 0 0 1 0-28.444444zM512 910.222222a56.888889 56.888889 0 1 1 56.888889-56.888889 56.888889 56.888889 0 0 1-56.888889 56.888889z m227.555556-170.666666H284.444444V170.666667h455.111112z"
                      p-id="2676"
                    ></path>
                  </svg>
                  +1 613-252-8014
                </a>
              </li>
            </ul>
          </div>
        </div>
        <hr />
        <div className="button-group row">
          <div className="col-md-6">
            <a
              className="button button-primary"
              href={resume}
              target="_blank"
              rel="noopener noreferrer"
            >
              Download CV
            </a>
          </div>
          <div className="col-md-6">
            <a
              className="button button-primary"
              href="https://github.com/yliu481"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span>
                <svg
                  viewBox="0 0 1024 1024"
                  version="1.1"
                  xmlns="http://www.w3.org/2000/svg"
                  p-id="5007"
                  height="24"
                  width="24"
                >
                  <path
                    d="M932 512a408 408 0 0 1-80.4 246.9 412.5 412.5 0 0 1-206.7 151.8 25.2 25.2 0 0 1-21.6-3.9 21.3 21.3 0 0 1-6.6-16.5v-115.2a98.1 98.1 0 0 0-28.5-77.7 390 390 0 0 0 55.8-9.6 204.6 204.6 0 0 0 51.3-21.6 154.5 154.5 0 0 0 44.1-36 172.5 172.5 0 0 0 30-57.6 275.4 275.4 0 0 0 11.4-82.5 158.1 158.1 0 0 0-43.5-112.5 145.2 145.2 0 0 0-4.2-111.6 71.7 71.7 0 0 0-44.1 6 281.7 281.7 0 0 0-50.4 24l-20.7 12.9a390 390 0 0 0-210 0c-6-4.2-13.5-8.7-23.1-14.7A305.7 305.7 0 0 0 338 272a77.7 77.7 0 0 0-47.1-7.5 147 147 0 0 0-3.9 112.5 162.9 162.9 0 0 0-43.2 113.1A270 270 0 0 0 255.2 572a184.2 184.2 0 0 0 30 57.6 142.5 142.5 0 0 0 44.1 36.6 251.1 251.1 0 0 0 51.3 21.6 388.2 388.2 0 0 0 56.1 9.6 86.7 86.7 0 0 0-27 56.4 93 93 0 0 1-24.9 7.8 156.9 156.9 0 0 1-30 2.7A64.8 64.8 0 0 1 316.4 752a102.6 102.6 0 0 1-30-34.2 90 90 0 0 0-26.4-28.5 75.6 75.6 0 0 0-27-13.2h-10.8a39 39 0 0 0-15.9 2.4q-4.5 2.7-2.7 6.3a41.4 41.4 0 0 0 5.1 7.5 51.9 51.9 0 0 0 7.2 6.9l3.9 2.4a73.2 73.2 0 0 1 24 20.7 147.9 147.9 0 0 1 17.1 27.6l5.4 12.6a67.8 67.8 0 0 0 24 33.9 90 90 0 0 0 36.3 15.6 183.9 183.9 0 0 0 37.8 3.9 170.7 170.7 0 0 0 30-2.1l12.6-2.1v78.6a21.6 21.6 0 0 1-7.2 16.5 26.1 26.1 0 0 1-21.9 3.9 410.7 410.7 0 0 1-205.5-152.7A401.1 401.1 0 0 1 92 512a410.1 410.1 0 0 1 56.4-210A415.8 415.8 0 0 1 302 148.4 410.1 410.1 0 0 1 512 92a410.1 410.1 0 0 1 210 56.4A415.8 415.8 0 0 1 875.6 302 409.5 409.5 0 0 1 932 512z"
                    p-id="5008"
                  ></path>
                </svg>
              </span>
              Github
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Bottom;
